<template>
  <page-header></page-header>
  <div class="innerBanner what-we-do-banner position-relative">
    <div class="inBannerImg">
      <img src="../../assets/what-we-do_banner.png" alt="Couriers" />
    </div>
    <div class="container-sm">
      <div class="col-lg-6 col-md-6">
        <div class="innerBannerText">
          <h1 class="text-uppercase">À PROPOS DE NOUS</h1>
          <span class="pe-lg-4 p-0"
            ><strong>Réseau de livraison du Canada</strong><br />
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="post-media_section text-center mt-5">
    <div class="container-sm">
      <p>
        Le Service de livraison de colis Postmedia est un service complet,
        fiable et digne de confiance qui prend en charge le commerce
        électronique et la livraison au détail pour les entreprises partout au
        Canada. Grâce à une technologie de pointe, nos clients peuvent être
        assurés que leurs colis sont entre de bonnes mains. Notre objectif est
        de fournir un service de livraison de qualité aux entreprises d'un océan
        à l'autre, de manière efficace et rapide, tout en tenant les clients
        informés tout au long du processus. En tant que division de Postmedia,
        l'un des plus grands réseaux de médias du Canada, nous savons comment
        acheminer votre colis jusqu'au seuil de votre porte partout au Canada.
      </p>
    </div>
  </div>

  <!--     <div class="we_integrate text-center">
        <div class="container-sm">
            <div class="row">
                <div class="col-lg-8 mx-auto">
                    <div class="we-integrate_subheading">We integrate tactics to</div>
                    <h2 class="my-3">MAXIMIZE YOUR IMPACT AND RETURN ON INVESTMENT</h2>
                    <p class="mb-3">on the Postmedia network and beyond.</p>
                    <a href="" class="bg-warning d-inline-block click-here-btn position-relative"><img src='https://postmediaparcelservices.com/wp-content/themes/bniparcel/images/arrow-reverse.png' alt="arrow" class="img-fluid"> Learn More</a>
                </div>
            </div>
        </div>
    </div> -->
  <div class="getInTouchSection">
    <div class="container-sm">
      <div class="getInTouch">
        <h5>
          <p>Vous avez besoin de plus d'informations ou de soutien ?</p>
          <a href="#/fr/support" title=""
            >PRENEZ CONTACT AVEC NOUS DÈS AUJOURD'HUI !</a
          >
        </h5>
      </div>
    </div>
  </div>

  <page-footer></page-footer>
</template>

<script>
import PageFooter from "../fr/PageFooter.vue";
import PageHeader from "../fr/PageHeader.vue";

export default {
  name: "track-your-shipment",
  components: {
    PageFooter,
    PageHeader,
  },
  beforeMount() {
    scroll(0, 0);
  },
};
</script>
